import { jsx as _jsx } from "react/jsx-runtime";
const Divider = ({ className = "" }) => {
    return _jsx("hr", { className: `border-0 bg-[#D1D1D6] h-px w-full ${className}` });
};
export default Divider;
//# sourceMappingURL=Divider.js.map